import { createAsyncThunk } from "@reduxjs/toolkit";
import { handlerMap } from "../../../network";
import { EmployeeViewType } from "../../../enums/employeeViewType";


/**
 * @deprecated
 * This function is deprecated and should not be used.
 */
export const fetchPaginatedEmployees = createAsyncThunk(
    "dashboard/fetchPaginatedEmployees",
    async ({ viewType, data }: { viewType: EmployeeViewType; data?: any }, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const handler = handlerMap[viewType];

        if (!handler) {
            console.error(`No handler found for viewType: ${viewType}`);
            return rejectWithValue(`Unsupported viewType: ${viewType}`);
        }

        try {
            const resultAction = await dispatch(handler(data)); // Dispatch the thunk

            // Check if the action was fulfilled and return the payload
            if (resultAction.meta.requestStatus === "fulfilled") {
                return { viewType, data: resultAction.payload };
            } else {
                throw resultAction.payload || new Error("Unhandled rejection");
            }
        } catch (error) {
            console.error(`Error fetching data for viewType: ${viewType}`, error);
            return rejectWithValue(error);
        }
    }
);
